import { TOKEN_SERVICE } from "./token.types";
import { Injectable, Inject } from "@webmotors/ioc";
import { Http, HTTP, HttpMethod } from "../http";
import { CONFIG, Config } from "@packages/config";
import { Logger, LOGGER } from "../logger";

@Injectable(TOKEN_SERVICE)
export class TokenService {
  private readonly logger: Logger;
  constructor(
    @Inject(HTTP)
    private readonly http: Http,
    @Inject(CONFIG)
    private readonly config: Config,
    @Inject(LOGGER) private readonly loggerFactory: Logger
  ) {
    this.logger = this.loggerFactory.create(TOKEN_SERVICE);
  }

  private get requestBaseURL() {
    return this.config.isServerSide()
      ? this.config.apiPrivateURL
      : this.config.apiURL;
  }

  async renewRefreshToken(refreshToken: string): Promise<any> {
    this.logger.log("[renewRefreshToken] ", refreshToken);
    if (!refreshToken) {
      this.logger.log("[renewRefreshToken] refreshToken não fornecido");
      throw new Error("Refresh token não fornecido");
    }

    try {
      const path = `${this.requestBaseURL}/v2/login/renewtoken`;
      const response = await this.http.request(path, {
        method: HttpMethod.POST,
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ refreshToken }),
      });

      return response;
    } catch (error) {
      this.logger.log("[renewRefreshToken] error: ", error);
      throw new Error(`[renewRefreshToken]: ${error}`);
    }
  }

  async revokeRefreshToken(email: string): Promise<any> {
    if (!email) {
      throw new Error("Usuário não fornecido");
    }

    try {
      const path = `${this.requestBaseURL}/v2/login/signout`;
      const response = await this.http.request(path, {
        method: HttpMethod.POST,
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ username: email }),
      });

      return response;
    } catch (error) {
      this.logger.log("[revokeRefreshToken] error: ", error);
      throw new Error(`[revokeRefreshToken]: ${error}`);
    }
  }
}
